import { Box } from "@mui/material";
import { NEUTRAL } from "../../../../theme/tokens";

/**
 * The one-column visual gap between two weeks inside a grid body row — a bare
 * neutral track. Shared by all three grids' body rows (the header rows draw a
 * different, sticky divider). Pass to `mapCalendarCells`' `renderDivider`.
 * Purely visual — `role="presentation"` keeps it out of the ARIA grid row.
 */
export const WeekDividerTrack = () => <Box role="presentation" sx={{ backgroundColor: NEUTRAL[150] }} />;
